import { AdoptBootstrapScript, ApplicationScript } from '../typings/application/ApplicationScript';

export const createYesElfIntegrationScript = ({
    applicationId,
    url = '',
    ifcNamespace = true,
    baseUrlSlug = 'sdk',
}: ApplicationScript): string => {
    const scriptUrl = `${url}/${baseUrlSlug}/${applicationId}/app.js`;

    return (
        `(function(i,s,o,g,r,a,m){i['YesElfApi']=r;i[r]=i[r]||function(){\n` +
        '\t(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n' +
        `\tm=s.getElementsByTagName(o)[0];a.async=1;a.id='yesElf';a.src=g;m.parentNode.insertBefore(a,m.nextSibling)})\n` +
        `\t(window,document,'script','${scriptUrl}','yesElf');\n` +
        `\tyesElf('id', '${applicationId}');\n` +
        `${!ifcNamespace ? `\tyesElf('ifcNamespace', false);\n` : ''}`
    );
};

export const ADOPT_SCRIPT_ID = 'adopt';

export const createAdoptBootstrapScript = ({
    rolloutPolicyId,
    scriptUrl,
    yeselfConfig,
    integrityAttribute,
}: Omit<AdoptBootstrapScript, 'useSystemIdentifier'>): HTMLScriptElement => {
    const element = document.createElement('script');

    element.id = ADOPT_SCRIPT_ID;
    element.type = 'text/javascript';
    element.setAttribute('async', 'true');
    element.setAttribute('data-client', rolloutPolicyId);
    element.src = scriptUrl;

    if (yeselfConfig) {
        element.setAttribute('data-yeself', JSON.stringify(yeselfConfig));
    }

    if (integrityAttribute) {
        element.setAttribute('integrity', integrityAttribute);
        element.setAttribute('crossorigin', 'anonymous');
    }

    return element;
};
